import { render, staticRenderFns } from "./publishPicture.vue?vue&type=template&id=72395342"
import script from "./publishPicture.vue?vue&type=script&lang=js"
export * from "./publishPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports